import { useEffect, useState } from 'react';
import { useLuraSignUserData } from './use-lura-sign-user-data';
import { LuraSignUserData } from '../../ts/interfaces/user/lura-sign-user-data';

export const useResolvedLuraSignUserData = (userZohoId?: string) => {
  const { getLuraSignUserDataAsync, isLoading, error } = useLuraSignUserData();

  const [data, setData] = useState<LuraSignUserData | null>(null);

  useEffect(() => {
    if (!userZohoId) return;

    const fetchData = async () => {
      const result = await getLuraSignUserDataAsync({ userZohoId,  });
      setData(result);
    };

    fetchData();
  }, [userZohoId]);

  return {
    luraSignUserData: data,
    isLoading,
    error,
  };
};
